'use strict';

import React, {PropTypes} from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { COMPANY_STATUS } from '../../../common/enums';

import CandidateIcon from '../../../common/svgs/CandidateIcon';
import ContactIcon from '../../../common/svgs/ContactIcon';
import CompanyIcon from '../../../common/svgs/CompanyIcon';
import JobRequestIcon from '../../../common/svgs/JobRequestIcon';
import LogoSmall from '../../../common/svgs/LogoSmall';
import MenuIcon from '../../../common/svgs/MenuIcon';

@connect((state) => ({
  contact: state.contactProfile,
  navState: state.ui.navState,
  allowAddJobRequest: (state.contactProfile.company.companyStatus === COMPANY_STATUS.QUALIFIED_PROSPECT
    || state.contactProfile.company.companyStatus === COMPANY_STATUS.ACTIVE_ACCOUNT
    || state.contactProfile.company.companyStatus === COMPANY_STATUS.INACTIVE_ACCOUNT),
  bqpMigrationFeature: state.staticData.featureToggles.find(feature => feature.hardcodelink === 'BQP_MIGRATION_FEATURE').value === true
}))

export default class NavigationContact extends React.Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    allowAddJobRequest: PropTypes.bool,
    bqpMigrationFeature: PropTypes.bool
  };

  constructor(props) {
    super(props);

    this.state = {
      isOpen : false,
      hideClose: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.navState && nextProps.navState.isOpen !== undefined) {

      this.setState(nextProps.navState);
    }
  }

  // eslint-disable-next-line no-unused-vars
  toggleNavigation = (event) => {
    this.setState({isOpen: !this.state.isOpen});
  }

  handleClick = (event, url) => {
    this.props.dispatch(push(url));
  }

  checkContactStatus = (event) => {

    this.handleClick(event, '/client/jobrequest');
  }

  isActiveSection(path) {
    return this.props.location.pathname === path;
  }
  isActiveSections(paths) {
    return !!~paths.indexOf(this.props.location.pathname.toLowerCase());
  }

  render() {
    const allowAddJobRequest = this.props.allowAddJobRequest && !this.props.bqpMigrationFeature;
    return (
      <div className={`navigation-contact ${(this.state.isOpen) ? ' open' : ''}  ${(this.state.isDisabled) ? ' disabled' : ''}`}>
        <LogoSmall collapsed={!this.state.isOpen} className='navigation-contact-logo' style={{color: '#fefefe', backgroundColor: '#161a21'}}/>
        <ul className='navigation-contact-list'>
          <li data-id='contact-dashboard' className={this.isActiveSection('/client') ? 'active' : ''}
            onClick={(event) => this.handleClick(event, '/client')}>
            <CandidateIcon />
            <label>My Account</label>
          </li>
          <li data-id='company-dashboard' className={this.isActiveSection('/client/company') ? 'active' : ''}
            onClick={(event) => this.handleClick(event, '/client/company')}>
            <CompanyIcon />
            <label>Company</label>
          </li>
          <li data-id='jobrequesthistory-link' className={this.isActiveSection('/client/jobrequesthistory') ? 'active' : ''}
            onClick={(event) => this.handleClick(event, '/client/jobrequesthistory')}>
            <JobRequestIcon />
            <label>Job Requests</label>
          </li>
        </ul>
        <ul className='navigation-contact-list menu'>
          {
            !this.props.bqpMigrationFeature &&
            <li data-id='add-contact-link' className={this.isActiveSection('/client/newcontact') ? 'active' : ''}
                onClick={(event) => this.handleClick(event, '/client/newcontact')}>
              <ContactIcon showPlus={true}/>
              <label>Add Contact</label>
            </li>
          }
          {
            allowAddJobRequest
            &&
            <li data-id='add-job-req-link' className={this.isActiveSection('/client/jobrequest') ? 'active' : ''}
                onClick={(event) => this.checkContactStatus(event)}>
              <JobRequestIcon showPlus={true}/>
              <label>Add Job Req.</label>
            </li>
          }
            <li data-id='close-btn' onClick={this.toggleNavigation}>
              <MenuIcon isOpen={this.state.isOpen} />
              <label>Close</label>
            </li>
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/client/Navigation/index.js